import { all, fork } from "redux-saga/effects";
import startup from "./StartupSaga";
import AuthSaga from "./auth/AuthSaga";
import AutorizacionSaga from "./autorizacion/AutorizacionSaga";
import MedicamentoSaga from "./medicamento/MedicamentoSaga";
import AseguradoSaga from "./asegurado/AseguradoSaga";
import AfiliadoFarmaCardSaga from "./afiliadoFarmaCard/AfiliadoFarmaCardSaga";
import PrestadorSaga from "./prestador/PrestadorSaga";
import ProcedimientoSaga from "./procedimiento/ProcedimientoSaga";
import PrecertificacionSaga from "./precertificacion/PrecertificacionSaga";
import CatalogoSaga from "./catalogo/CatalogoSaga";
import VoucherSaga from "./voucher/VoucherSaga";
import ConfiguracionSaga from "./configuracion/ConfiguracionSaga";
import EgresosSaga from "./Egresos/EgresosSaga";
import HojasQuirurgicasSaga from "./hospitalizacion/HojasQuirurgicasSaga";
import OrdsInfoplanSaga from "./ordsInfoplan/OrdsInfoplanSaga";

export default function* root() {
  yield fork(startup);
  yield all([
    ...AuthSaga,
    ...AutorizacionSaga,
    ...MedicamentoSaga,
    ...AseguradoSaga,
    ...AfiliadoFarmaCardSaga,
    ...PrestadorSaga,
    ...ProcedimientoSaga,
    ...PrecertificacionSaga,
    ...CatalogoSaga,
    ...VoucherSaga,
    ...ConfiguracionSaga,
    ...EgresosSaga,
    ...HojasQuirurgicasSaga,
    ...OrdsInfoplanSaga,
  ]);
}
